module.exports = __webpack_public_path__ + "img/Bank_check_ic_normal_white.ebf4c21.svg";